import { render, staticRenderFns } from "./SystemError.vue?vue&type=template&id=feb6a12c&"
import script from "./SystemError.vue?vue&type=script&lang=ts&"
export * from "./SystemError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports